import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const editMetaAction = createAsyncThunk(
    'edit-meta',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.put(`/support-server/api/edit-meta`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const editMetaSlice = createSlice({
    name: 'edit-meta',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(editMetaAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(editMetaAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(editMetaAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const editMetaReducer = editMetaSlice.reducer